import React, { Component } from 'react';

import './Loader.scss';
import { Images } from '../../Tenants';

export default class Loader extends Component {
   render() {
      const { center, style={} } = this.props;      
      let loaderImage = Images?.loader;
      let loader = loaderImage;

      return (
         center === true ?
            <div style={{
               position: 'absolute',
               display: 'flex',
               top: 0,
               bottom: 0,
               right: 0,
               left: 0,
               justifyContent: 'center',
               alignItems: 'center',
               zIndex:3
            }}>
               <img style={{ width: '100px', height: '100px' , position:this.props.position?"fixed":""}} src={loader}></img>
            </div>
            :
            <div className='loader' style={style}>
               <img style={{ width: '100px', height: '100px' }} src={loader}></img>
            </div>
      )
   }
}


